import BlogsComp from "../components/Blogs/BlogsComp";

const Blogs = () => {
  return (
    <div className="min-h-screen pt-14 bg-gray-100">
      <BlogsComp />
    </div>
  );
};

export default Blogs;
